import { render, staticRenderFns } from "./Hours-issue.vue?vue&type=template&id=48f6f8e3"
import script from "./Hours-issue.vue?vue&type=script&lang=js"
export * from "./Hours-issue.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports